import { render, staticRenderFns } from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=template&id=15583c59&"
import script from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports